import '../../assets/index43.css';var Co = Object.defineProperty, go = Object.defineProperties;
var bo = Object.getOwnPropertyDescriptors;
var L = Object.getOwnPropertySymbols;
var ao = Object.prototype.hasOwnProperty, io = Object.prototype.propertyIsEnumerable;
var eo = (o, e, r) => e in o ? Co(o, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : o[e] = r, n = (o, e) => {
  for (var r in e || (e = {}))
    ao.call(e, r) && eo(o, r, e[r]);
  if (L)
    for (var r of L(e))
      io.call(e, r) && eo(o, r, e[r]);
  return o;
}, v = (o, e) => go(o, bo(e));
var S = (o, e) => {
  var r = {};
  for (var a in o)
    ao.call(o, a) && e.indexOf(a) < 0 && (r[a] = o[a]);
  if (o != null && L)
    for (var a of L(o))
      e.indexOf(a) < 0 && io.call(o, a) && (r[a] = o[a]);
  return r;
};
import { jsx as d, jsxs as Io } from "react/jsx-runtime";
import { createContext as wo, forwardRef as so, useContext as ko } from "react";
import { ErrorMessage as xo } from "../../molecules/ErrorMessage/index.js";
import { useForwardedRef as Go } from "../../hooks/useForwardedRef.js";
import { Label as Po } from "../Label/index.js";
import { e as K, c as E } from "../../get-size-BzhHC8s2.js";
import { u as M, c as W } from "../../use-styles-BXCSW-9F.js";
import { j as D, b as F, B as j, p as no, f as V, e as Ao } from "../../factory-BnRIVbT0.js";
import { g as to } from "../../get-contrast-color-CmlzE11I.js";
import { g as co } from "../../get-auto-contrast-value-BGSSZ1GD.js";
import { I as So, a as zo } from "../../InputsGroupFieldset-D5kPQX6u.js";
import { u as No } from "../../DirectionProvider-CT8S13Cp.js";
import { U as Bo } from "../../UnstyledButton-DHpnv8SC.js";
import { c as lo } from "../../create-optional-context-CQ2ahjKQ.js";
import { I as uo } from "../../Input-DhXon_Er.js";
import { u as mo } from "../../use-id-D2tGiO9x.js";
import { u as $o } from "../../use-uncontrolled-BT_j5D2R.js";
import { r as O } from "../../rem-CMQJ_ZTp.js";
import { F as Lo } from "../../Flex-B_Eo0AIL.js";
const [Eo, po] = lo(), [Vo, Do] = lo();
var fo = { card: "m_9dc8ae12" };
const Fo = {
  withBorder: !0
}, To = W((o, { radius: e }) => ({
  card: {
    "--card-radius": K(e)
  }
})), q = D((o, e) => {
  const r = F("RadioCard", Fo, o), y = r, {
    classNames: a,
    className: t,
    style: c,
    styles: s,
    unstyled: i,
    vars: l,
    checked: C,
    mod: R,
    withBorder: k,
    value: m,
    onClick: h,
    name: x,
    onKeyDown: g
  } = y, b = S(y, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "checked",
    "mod",
    "withBorder",
    "value",
    "onClick",
    "name",
    "onKeyDown"
  ]), B = M({
    name: "RadioCard",
    classes: fo,
    props: r,
    className: t,
    style: c,
    classNames: a,
    styles: s,
    unstyled: i,
    vars: l,
    varsResolver: To,
    rootSelector: "card"
  }), { dir: I } = No(), p = po(), G = typeof C == "boolean" ? C : (p == null ? void 0 : p.value) === m || !1, P = x || (p == null ? void 0 : p.name), $ = (_) => {
    if (g == null || g(_), ["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"].includes(_.nativeEvent.code)) {
      _.preventDefault();
      const f = Array.from(
        document.querySelectorAll(
          `[role="radio"][name="${P || "__mantine"}"]`
        )
      ), w = f.findIndex((T) => T === _.target), u = w + 1 >= f.length ? 0 : w + 1, A = w - 1 < 0 ? f.length - 1 : w - 1;
      _.nativeEvent.code === "ArrowDown" && (f[u].focus(), f[u].click()), _.nativeEvent.code === "ArrowUp" && (f[A].focus(), f[A].click()), _.nativeEvent.code === "ArrowLeft" && (f[I === "ltr" ? A : u].focus(), f[I === "ltr" ? A : u].click()), _.nativeEvent.code === "ArrowRight" && (f[I === "ltr" ? u : A].focus(), f[I === "ltr" ? u : A].click());
    }
  };
  return /* @__PURE__ */ d(Vo, { value: { checked: G }, children: /* @__PURE__ */ d(
    Bo,
    v(n(n({
      ref: e,
      mod: [{ "with-border": k, checked: G }, R]
    }, B("card")), b), {
      role: "radio",
      "aria-checked": G,
      name: P,
      onClick: (_) => {
        h == null || h(_), p == null || p.onChange(m || "");
      },
      onKeyDown: $
    })
  ) });
});
q.displayName = "@mantine/core/RadioCard";
q.classes = fo;
const Uo = {}, H = D((o, e) => {
  const g = F("RadioGroup", Uo, o), { value: r, defaultValue: a, onChange: t, size: c, wrapperProps: s, children: i, name: l, readOnly: C } = g, R = S(g, ["value", "defaultValue", "onChange", "size", "wrapperProps", "children", "name", "readOnly"]), k = mo(l), [m, h] = $o({
    value: r,
    defaultValue: a,
    finalValue: "",
    onChange: t
  });
  return /* @__PURE__ */ d(Eo, { value: { value: m, onChange: (b) => !C && h(typeof b == "string" ? b : b.currentTarget.value), size: c, name: k }, children: /* @__PURE__ */ d(
    uo.Wrapper,
    v(n(n({
      size: c,
      ref: e
    }, s), R), {
      labelElement: "div",
      __staticSelector: "RadioGroup",
      children: /* @__PURE__ */ d(So, { role: "radiogroup", children: i })
    })
  ) });
});
H.classes = uo.Wrapper.classes;
H.displayName = "@mantine/core/RadioGroup";
function vo(a) {
  var t = a, { size: o, style: e } = t, r = S(t, ["size", "style"]);
  return /* @__PURE__ */ d(
    "svg",
    v(n({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 5 5",
      style: n({ width: O(o), height: O(o) }, e),
      "aria-hidden": !0
    }, r), {
      children: /* @__PURE__ */ d("circle", { cx: "2.5", cy: "2.5", r: "2.5", fill: "currentColor" })
    })
  );
}
var _o = { indicator: "m_717d7ff6", icon: "m_3e4da632", "indicator--outline": "m_2980836c" };
const jo = {
  icon: vo
}, Oo = W(
  (o, { radius: e, color: r, size: a, iconColor: t, variant: c, autoContrast: s }) => {
    const i = no({ color: r || o.primaryColor, theme: o }), l = i.isThemeColor && i.shade === void 0 ? `var(--mantine-color-${i.color}-outline)` : i.color;
    return {
      indicator: {
        "--radio-size": E(a, "radio-size"),
        "--radio-radius": e === void 0 ? void 0 : K(e),
        "--radio-color": c === "outline" ? l : V(r, o),
        "--radio-icon-size": E(a, "radio-icon-size"),
        "--radio-icon-color": t ? V(t, o) : co(s, o) ? to({ color: r, theme: o, autoContrast: s }) : void 0
      }
    };
  }
), Y = D((o, e) => {
  const r = F("RadioIndicator", jo, o), y = r, {
    classNames: a,
    className: t,
    style: c,
    styles: s,
    unstyled: i,
    vars: l,
    icon: C,
    radius: R,
    color: k,
    iconColor: m,
    autoContrast: h,
    checked: x,
    mod: g,
    variant: b,
    disabled: B
  } = y, I = S(y, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "icon",
    "radius",
    "color",
    "iconColor",
    "autoContrast",
    "checked",
    "mod",
    "variant",
    "disabled"
  ]), p = C, G = M({
    name: "RadioIndicator",
    classes: _o,
    props: r,
    className: t,
    style: c,
    classNames: a,
    styles: s,
    unstyled: i,
    vars: l,
    varsResolver: Oo,
    rootSelector: "indicator"
  }), P = Do(), $ = typeof x == "boolean" ? x : (P == null ? void 0 : P.checked) || !1;
  return /* @__PURE__ */ d(
    j,
    v(n(v(n({
      ref: e
    }, G("indicator", { variant: b })), {
      variant: b,
      mod: [{ checked: $, disabled: B }, g]
    }), I), {
      children: /* @__PURE__ */ d(p, n({}, G("icon")))
    })
  );
});
Y.displayName = "@mantine/core/RadioIndicator";
Y.classes = _o;
var ho = { root: "m_f3f1af94", inner: "m_89c4f5e4", icon: "m_f3ed6b2b", radio: "m_8a3dbb89", "radio--outline": "m_1bfe9d39" };
const Ko = {
  labelPosition: "right"
}, Mo = W(
  (o, { size: e, radius: r, color: a, iconColor: t, variant: c, autoContrast: s }) => {
    const i = no({ color: a || o.primaryColor, theme: o }), l = i.isThemeColor && i.shade === void 0 ? `var(--mantine-color-${i.color}-outline)` : i.color;
    return {
      root: {
        "--radio-size": E(e, "radio-size"),
        "--radio-radius": r === void 0 ? void 0 : K(r),
        "--radio-color": c === "outline" ? l : V(a, o),
        "--radio-icon-color": t ? V(t, o) : co(s, o) ? to({ color: a, theme: o, autoContrast: s }) : void 0,
        "--radio-icon-size": E(e, "radio-icon-size")
      }
    };
  }
), N = D((o, e) => {
  var X, oo;
  const r = F("Radio", Ko, o), Q = r, {
    classNames: a,
    className: t,
    style: c,
    styles: s,
    unstyled: i,
    vars: l,
    id: C,
    size: R,
    label: k,
    labelPosition: m,
    description: h,
    error: x,
    radius: g,
    color: b,
    variant: B,
    disabled: I,
    wrapperProps: p,
    icon: G = vo,
    rootRef: P,
    iconColor: $,
    onChange: y,
    mod: _
  } = Q, f = S(Q, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "id",
    "size",
    "label",
    "labelPosition",
    "description",
    "error",
    "radius",
    "color",
    "variant",
    "disabled",
    "wrapperProps",
    "icon",
    "rootRef",
    "iconColor",
    "onChange",
    "mod"
  ]), w = M({
    name: "Radio",
    classes: ho,
    props: r,
    className: t,
    style: c,
    classNames: a,
    styles: s,
    unstyled: i,
    vars: l,
    varsResolver: Mo
  }), u = po(), A = (X = u == null ? void 0 : u.size) != null ? X : R, T = r.size ? R : A, { styleProps: yo, rest: U } = Ao(f), Z = mo(C), J = u ? {
    checked: u.value === U.value,
    name: (oo = U.name) != null ? oo : u.name,
    onChange: (ro) => {
      u.onChange(ro), y == null || y(ro);
    }
  } : {};
  return /* @__PURE__ */ d(
    zo,
    v(n(n(v(n({}, w("root")), {
      __staticSelector: "Radio",
      __stylesApiProps: r,
      id: Z,
      size: T,
      labelPosition: m,
      label: k,
      description: h,
      error: x,
      disabled: I,
      classNames: a,
      styles: s,
      unstyled: i,
      "data-checked": J.checked || void 0,
      variant: B,
      ref: P,
      mod: _
    }), yo), p), {
      children: /* @__PURE__ */ Io(j, v(n({}, w("inner")), { mod: { "label-position": m }, children: [
        /* @__PURE__ */ d(
          j,
          v(n(n(v(n({}, w("radio", { focusable: !0, variant: B })), {
            onChange: y
          }), U), J), {
            component: "input",
            mod: { error: !!x },
            ref: e,
            id: Z,
            disabled: I,
            type: "radio"
          })
        ),
        /* @__PURE__ */ d(G, v(n({}, w("icon")), { "aria-hidden": !0 }))
      ] }))
    })
  );
});
N.classes = ho;
N.displayName = "@mantine/core/Radio";
N.Group = H;
N.Card = q;
N.Indicator = Y;
const Wo = "Radio-module__radioGroupLabel___A7yIY", qo = "Radio-module__radio___dpBlV", Ho = "Radio-module__radioIcon___ynpHz", Yo = "Radio-module__radioInner___bZRFE", Zo = "Radio-module__radioBody___i-NSh", Jo = "Radio-module__radioLabel___VxVM0", z = {
  radioGroupLabel: Wo,
  radio: qo,
  radioIcon: Ho,
  radioInner: Yo,
  radioBody: Zo,
  radioLabel: Jo
}, Ro = wo({}), Qo = so((C, l) => {
  var R = C, {
    clearable: o = !1,
    error: e,
    horizontal: r,
    onChange: a,
    value: t,
    label: c,
    required: s
  } = R, i = S(R, [
    "clearable",
    "error",
    "horizontal",
    "onChange",
    "value",
    "label",
    "required"
  ]);
  const k = (m) => {
    if (!m.current)
      return;
    const h = m.current.checked;
    m.current.checked = !h, a(h ? null : m.current.value);
  };
  return /* @__PURE__ */ d(
    N.Group,
    v(n({
      "aria-invalid": !!e,
      classNames: {
        label: z.radioGroupLabel,
        root: z.radioGroupRoot
      },
      error: e && /* @__PURE__ */ d(xo, { error: e }),
      onChange: a,
      ref: l,
      value: t,
      label: typeof c == "string" ? /* @__PURE__ */ d(Po, { label: c, withAsterisk: s }) : c
    }, i), {
      children: /* @__PURE__ */ d(Ro.Provider, { value: o && { onClick: k } || {}, children: /* @__PURE__ */ d(Lo, { direction: r ? "row" : "column", gap: O(r ? 24 : 8), children: i.children }) })
    })
  );
}), Xo = so((t, a) => {
  var c = t, { label: o, disabled: e } = c, r = S(c, ["label", "disabled"]);
  const { onClick: s } = ko(Ro), i = Go(a);
  return /* @__PURE__ */ d(
    N,
    n({
      classNames: {
        body: z.radioBody,
        icon: z.radioIcon,
        inner: z.radioInner,
        label: z.radioLabel,
        radio: z.radio
      },
      disabled: e,
      label: o,
      onClick: s && (() => s(i)),
      onKeyDown: (l) => {
        i.current && l.key === " " && (l.preventDefault(), s && s(i));
      },
      ref: i,
      variant: "outline"
    }, r)
  );
}), Cr = Object.assign({}, Xo, {
  Group: Qo
});
export {
  Cr as Radio
};
